export default __webpack_public_path__ + "smop-reset.5675fae3116e8c1b876fcb23204ad8d9.svg";